module.exports = __webpack_public_path__ + "static/img/aa.72ade61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/aa.png
// module id = wyjO
// module chunks = 0